import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/map-control-settings.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
